<template>
  <div class="relative">
    <select
      v-model="selectedLanguage"
      class="form-select block w-full pl-3 pr-10 py-2 text-sm leading-5 text-white bg-gray-700 border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
      @change="changeLanguage"
    >
      <option v-for="lang in availableLanguages" :key="lang" :value="lang">
        {{ $t(`languages.${lang}`) }}
      </option>
    </select>
  </div>
</template>

<script>
import { defaultLocale } from '../../i18n/i18n-config';

export default {
  name: 'LanguageSelector',
  data() {
    return {
      selectedLanguage: this.$i18n.locale
    };
  },
  methods: {
    changeLanguage() {
      const currentPath = window.location.pathname;
      const pathParts = currentPath.split('/');

      // Remove the current language prefix if it exists
      if (this.availableLanguages.includes(pathParts[1])) {
        pathParts.splice(1, 1);
      }

      // Add the new language prefix
      if (this.selectedLanguage !== defaultLocale) {
        pathParts.splice(1, 0, this.selectedLanguage);
      }

      // Update the URL
      const newPath = pathParts.join('/');
      window.location.href = newPath;
    }
  },
  computed: {
    availableLanguages() {
      return Object.keys(this.$i18n.messages);
    }
  }
};
</script>
